/**
 * @generated SignedSource<<37c275f236eeacae35c59cf942736ea5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BoardColumnOld_view$data = {
  readonly columns: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly statuses?: ReadonlyArray<{
          readonly name: string;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined>;
  };
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"BoardCard_view" | "StatusColumnHeader_view">;
  readonly " $fragmentType": "BoardColumnOld_view";
};
export type BoardColumnOld_view$key = {
  readonly " $data"?: BoardColumnOld_view$data;
  readonly " $fragmentSpreads": FragmentRefs<"BoardColumnOld_view">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "columns"
        ]
      }
    ]
  },
  "name": "BoardColumnOld_view",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "FragmentSpread",
      "name": "BoardCard_view"
    },
    {
      "kind": "FragmentSpread",
      "name": "StatusColumnHeader_view"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": "columns",
        "concreteType": "JiraBoardViewColumnConnection",
        "kind": "LinkedField",
        "name": "__business_board_columns_connection",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "JiraBoardViewColumnEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "concreteType": "JiraStatus",
                          "kind": "LinkedField",
                          "name": "statuses",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "RequiredField",
                              "field": {
                                "kind": "ScalarField",
                                "name": "name"
                              },
                              "action": "THROW",
                              "path": "columns.edges.node.statuses.name"
                            }
                          ]
                        }
                      ],
                      "type": "JiraBoardViewStatusColumn"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "__typename"
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "cursor"
                }
              ]
            },
            "action": "THROW",
            "path": "columns.edges"
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          }
        ]
      },
      "action": "THROW",
      "path": "columns"
    }
  ],
  "type": "JiraBoardView"
};

(node as any).hash = "5787bebac91e23670b522fe96efbcb85";

export default node;
